import { useQuery, gql } from "@apollo/client";
import useRetryOn429 from "hooks/useRetryOn429";

const FETCH_ODOO_DELIVERY_METHODS = gql`
  query FETCH_ODOO_DELIVERY_METHODS($company: String!) {
    odooDeliveryMethods(company: $company)
  }
`;

const useOdooDeliveryMethods = (company) => {
  const { loading, error, data, refetch } = useQuery(FETCH_ODOO_DELIVERY_METHODS, {
    variables: { company },
  });
  const { isAutoRetrying } = useRetryOn429({ error, refetch });
  const odooDeliveryMethods = data
    ? JSON.parse(data.odooDeliveryMethods)
    : null;
  return { loading, error, odooDeliveryMethods, isAutoRetrying };
};

export default useOdooDeliveryMethods;
